import React, { useState } from "react";
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function VendorActions({ selection, editEnable }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const closeWith = (val) => {
        setAnchorEl(null);
        selection(val);
    };

    return (
        <div>
            <Button
                variant="contained"
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{ minHeight: 36, px: 1.75 }}
            >
                Actions
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <MenuItem disabled={!editEnable || (Array.isArray(editEnable) && editEnable.length !== 1)} onClick={() => closeWith('edit')}>Edit vendor</MenuItem>
                <MenuItem onClick={() => closeWith('addVendor')}>New vendor</MenuItem>
                <MenuItem disabled={!editEnable || (Array.isArray(editEnable) && editEnable.length !== 1)} onClick={() => closeWith('placeOrder')}>Place order</MenuItem>
            </Menu>
        </div>
    );
}
